import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'
import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { TenderRepository } from '../infra/TenderRepository'

export type AcceptTenderFactoryDependencies = {
  tenderRepository: TenderRepository
}

export function acceptTenderFactory({ tenderRepository }: AcceptTenderFactoryDependencies) {
  return async function acceptTenderImpl(id: string, config?: { signal?: AbortSignal }) {
    await tenderRepository.acceptTender(id, config)
    return tenderRepository.getTenderById(id, config)
  }
}

export function acceptTender(id: string, config?: { signal?: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)
  const shipperGuideHttpClient = new ShipperGuideClient()
  const tenderRepository = new TenderRepository({ httpClient, shipperGuideHttpClient })
  const newAcceptTender = acceptTenderFactory({ tenderRepository })
  return newAcceptTender(id, config)
}
